export default {"src":"/_next/static/media/error-page-image.68c06b69.svg","height":152,"width":235,"blurWidth":0,"blurHeight":0};